module.exports = __webpack_public_path__ + "img/settings5.15f776cf.png";